import Firestore from '../initFirebase'
import { globalOnDemandVars } from '../../helper/context'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'
import { createFragment } from './createFragment'

export async function createUploadType2 (id, input) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return
  }

  const reference = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('UploadType2s')
    .doc(id)

  if (typeof input.content !== 'string') {
    input.content = JSON.stringify(input.content)
  }

  try {
    savingStart()
    if (input.fragmentList) {
      input.fragmentList.forEach((fragment) => {
        createFragment(id, fragment.id, {
          id: fragment.id,
          uploadType2Id: fragment.uploadType2Id,
          kind: fragment.kind,
          textAnswer: fragment.textAnswer,
          learningRecord: fragment.learningRecord,
          timeStamp: fragment.timeStamp,
          cropConfig: fragment.cropConfig
        })
      })

      delete input.fragmentList
    }
    await reference.set(input)
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'uploadType2 / createData.js')
  }
}
